import { Star } from "lucide-react";

/**
 * EliteBadge (V3.2 · additif)
 * Affichage du badge ⭐ AFRICTAL Elite Talent partout dans l'app
 * (profil, recherche, matching, messagerie, recommandations).
 */
export default function EliteBadge({ size = "md", showLabel = true, "data-testid": testid }) {
  const sm = size === "sm";
  return (
    <span
      title="AFRICTAL Elite Talent"
      data-testid={testid || "elite-badge"}
      style={{
        display: "inline-flex", alignItems: "center", gap: sm ? 2 : 3,
        padding: sm ? "1px 5px" : "2px 8px",
        borderRadius: 999,
        background: "linear-gradient(135deg,#F59E0B,#B45309)",
        color: "#fff",
        fontSize: sm ? 9 : 10,
        fontWeight: 700, letterSpacing: 0.3,
        lineHeight: 1.2, verticalAlign: "middle",
        boxShadow: "0 1px 3px rgba(245,158,11,0.4)",
      }}
    >
      <Star size={sm ? 9 : 10} fill="#fff" />
      {showLabel && "ELITE"}
    </span>
  );
}

/**
 * Hook to fetch the set of Elite user IDs once and reuse in listings.
 * Cached in module scope during the session.
 */
let cachedIds = null;
let cachedAt = 0;

export async function fetchEliteIds(api) {
  const now = Date.now();
  if (cachedIds && now - cachedAt < 60000) return cachedIds; // 60s cache
  try {
    const { data } = await api.get("/v1/elite/ids");
    cachedIds = new Set(data.ids || []);
    cachedAt = now;
  } catch {
    cachedIds = new Set();
  }
  return cachedIds;
}

export function invalidateEliteIds() {
  cachedIds = null;
  cachedAt = 0;
}
